export default [
  {
    id: "1",
    // type: "input",
    type: "initial",
    data: { label: "", nodeType: "initial" },
    position: { x: 300, y: 35 },
    // position: { x: 0, y: 0 },
    className: "customNodeStyle",
  },
  // {
  //   id: "2",
  //   // type: "input",
  //   type: "addNode",
  //   data: { label: "", nodeType: "addNode" },
  //   position: { x: 100, y: 150 },
  //   className: "customNodeStyle",
  // },
  // {
  //   id: "1",
  //   // type: "input",
  //   type: "custom",
  //   data: { label: "List Created", nodeType: "list" },
  //   position: { x: 100, y: 100 },
  //   className: "customNodeStyle",
  // },
  // {
  //   id: "2",
  //   type: "tooltip",
  //   data: { label: "Print yes" },
  //   position: { x: 150, y: 250 },
  // },
  // {
  //   id: "2",
  //   data: { label: "ADD STEPS", endNode: true },
  //   type: "default",
  //   position: { x: 114, y: 250 },
  //   style: {
  //     background: "#2E7D32",
  //     color: "white",
  //     // width: 100,
  //   },
  // },
  // { id: "4", data: { label: "Print No" }, position: { x: 0, y: 400 } },
  // { id: "5", data: { label: "Retake test" }, position: { x: 0, y: 500 } },
  // {
  //   id: "6",
  //   data: { label: "ADD STEPS" },
  //   position: { x: 0, y: 600 },
  //   // type: "output",
  //   style: {
  //     background: "#2E7D32",
  //     color: "white",
  //     width: 100,
  //   },
  // },

  // {
  //   id: "8",
  //   type: "output",
  //   data: { label: "User's Output / End application" },
  //   position: { x: 500, y: 650 },
  // },
];
